import to from "@/helpers/requests/to";

export default {
  to,
};
